import { WHATSAPP_BASE } from "./contacto";

export type CategoriaProducto = "stands" | "tarjetas" | "llaveros" | "personalizados";

export type DisponibilidadProducto = "disponible" | "a-pedido";

export type Producto = {
  id: string;
  name: string;
  description: string;
  price: string;
  priceValue: number;
  tag: string;
  category: CategoriaProducto;
  availability: DisponibilidadProducto;
  image: string;
  gallery?: string[];
  imageFit?: "cover" | "contain";
  imageZoom?: "keychain" | "medium";
  imageSurface?: string;
  featured?: boolean;
};

export const CATEGORIAS_PRODUCTO: Array<{
  id: CategoriaProducto;
  label: string;
  shortLabel: string;
}> = [
  { id: "stands", label: "Stands NFC + QR", shortLabel: "Stands" },
  { id: "tarjetas", label: "Tarjetas NFC", shortLabel: "Tarjetas" },
  { id: "llaveros", label: "Llaveros NFC", shortLabel: "Llaveros" },
  { id: "personalizados", label: "Productos personalizados", shortLabel: "Personalizados" },
];

export const productos: Producto[] = [
  {
    id: "stand-google",
    name: "Stand Google negro NFC + QR",
    description: "Acceso directo al formulario de reseña de Google mediante NFC y QR.",
    price: "$20.000",
    priceValue: 20000,
    tag: "Más vendido",
    category: "stands",
    availability: "disponible",
    image: "/productos/stand-google-negro.webp",
    gallery: [
      "/productos/stand-google-negro.webp",
      "/clientes/stand-nfc-qr-coni-nails.jpg",
      "/productos/stand-google-negro-catalogo.webp",
    ],
    imageFit: "contain",
    imageSurface: "bg-[#e9dfcc]",
    featured: true,
  },
  {
    id: "stand-google-blanco",
    name: "Stand Google blanco NFC + QR",
    description: "La misma conexión directa a reseñas de Google, en terminación blanca.",
    price: "$20.000",
    priceValue: 20000,
    tag: "Opción clara",
    category: "stands",
    availability: "disponible",
    image: "/productos/stand-google-blanco.webp",
    gallery: [
      "/productos/stand-google-blanco.webp",
      "/clientes/stand-nfc-qr-festa-gelateria.webp",
      "/clientes/stand-nfc-qr-kantu-food.webp",
      "/clientes/stand-nfc-qr-moscowa-restobar.webp",
      "/clientes/stand-nfc-qr-intensos-parfums.webp",
      "/productos/stand-google-blanco-catalogo.webp",
    ],
    imageFit: "contain",
    imageSurface: "bg-[#e9dfcc]",
    featured: true,
  },
  {
    id: "stand-instagram",
    name: "Stand Instagram NFC + QR",
    description: "Lleva a tus clientes directamente a tu perfil de Instagram con un toque.",
    price: "$20.000",
    priceValue: 20000,
    tag: "Redes sociales",
    category: "stands",
    availability: "disponible",
    image: "/productos/stand-instagram.webp",
    gallery: [
      "/productos/stand-instagram.webp",
      "/clientes/stand-nfc-qr-bgo.webp",
      "/clientes/stand-nfc-qr-muuy-mucho.webp",
      "/productos/stand-instagram-catalogo.webp",
    ],
    imageFit: "contain",
    imageSurface: "bg-[#e4ddcf]",
  },
  {
    id: "stand-whatsapp",
    name: "Stand WhatsApp NFC + QR",
    description: "Abre una conversación con tu negocio mediante NFC o escaneando el QR.",
    price: "$20.000",
    priceValue: 20000,
    tag: "Contacto directo",
    category: "stands",
    availability: "disponible",
    image: "/productos/stand-whatsapp-catalogo.webp",
    gallery: ["/productos/stand-whatsapp-catalogo.webp", "/productos/stand-whatsapp.webp"],
    imageFit: "contain",
    imageSurface: "bg-[#d9dfa8]",
  },
  {
    id: "stand-tiktok",
    name: "Stand TikTok NFC + QR",
    description: "Lleva a tus clientes directamente a tu perfil de TikTok mediante NFC y QR.",
    price: "$20.000",
    priceValue: 20000,
    tag: "TikTok",
    category: "stands",
    availability: "disponible",
    image: "/productos/stand-tiktok-catalogo.webp",
    gallery: ["/productos/stand-tiktok-catalogo.webp"],
    imageFit: "contain",
    imageSurface: "bg-[#d1d0d1] ring-1 ring-inset ring-ink/10",
  },
  {
    id: "stand-personalizado",
    name: "Stand personalizado NFC + QR",
    description: "Diseño adaptado a tu marca y conectado al enlace que necesite tu negocio.",
    price: "$30.000",
    priceValue: 30000,
    tag: "Tu marca",
    category: "personalizados",
    availability: "a-pedido",
    image: "/clientes/stand-personalizado-optica-luz.webp",
    gallery: ["/clientes/stand-personalizado-optica-luz.webp"],
    imageFit: "contain",
    imageZoom: "medium",
    imageSurface: "bg-[#eef2f5]",
  },
  {
    id: "adhesivo-personalizado",
    name: "Adhesivo personalizado NFC + QR",
    description: "Formato para vitrinas y vidrios, diseñado con la identidad de tu negocio.",
    price: "$20.000",
    priceValue: 20000,
    tag: "Para vitrinas",
    category: "personalizados",
    availability: "a-pedido",
    image: "/clientes/adhesivo-personalizado-optica-luz.webp",
    gallery: ["/clientes/adhesivo-personalizado-optica-luz.webp"],
    imageFit: "contain",
    imageSurface: "bg-[#e8edf0]",
  },
  {
    id: "tarjeta-google",
    name: "Tarjeta Google NFC",
    description: "Tarjeta NFC para acercar a tus clientes a las reseñas de tu negocio.",
    price: "$10.000",
    priceValue: 10000,
    tag: "Google Reviews",
    category: "tarjetas",
    availability: "disponible",
    image: "/productos/tarjetas-google.webp",
    gallery: ["/productos/tarjetas-google.webp", "/productos/tarjeta-google.webp"],
    imageFit: "contain",
    imageSurface: "bg-[#e6ddcc]",
  },
  {
    id: "llavero-instagram",
    name: "Llavero Instagram NFC + QR",
    description: "Lleva tu perfil de Instagram contigo y compártelo mediante NFC o QR.",
    price: "$10.000",
    priceValue: 10000,
    tag: "Instagram",
    category: "llaveros",
    availability: "disponible",
    image: "/productos/llavero-instagram-frontal.webp",
    gallery: [
      "/productos/llavero-instagram-frontal.webp",
      "/productos/llavero-instagram-posterior.webp",
    ],
    imageFit: "contain",
    imageZoom: "keychain",
    imageSurface: "bg-[#dededc]",
  },
  {
    id: "llavero-google-negro",
    name: "Llavero Google negro NFC",
    description: "Acceso portátil a tus reseñas de Google mediante chip NFC.",
    price: "$10.000",
    priceValue: 10000,
    tag: "Google",
    category: "llaveros",
    availability: "disponible",
    image: "/productos/llavero-google-negro-frontal.webp",
    gallery: [
      "/productos/llavero-google-negro-frontal.webp",
      "/productos/llavero-google-negro-posterior.webp",
    ],
    imageFit: "contain",
    imageZoom: "keychain",
    imageSurface: "bg-[#dededc]",
  },
  {
    id: "llavero-google-blanco",
    name: "Llavero Google blanco NFC",
    description: "Versión blanca para compartir el acceso a tus reseñas de Google.",
    price: "$10.000",
    priceValue: 10000,
    tag: "Google blanco",
    category: "llaveros",
    availability: "disponible",
    image: "/productos/llavero-google-blanco-frontal.webp",
    gallery: [
      "/productos/llavero-google-blanco-frontal.webp",
      "/productos/llavero-google-blanco-posterior.webp",
      "/productos/llavero-google-ambiente.webp",
    ],
    imageFit: "contain",
    imageZoom: "keychain",
    imageSurface: "bg-[#dededc]",
  },
  {
    id: "llavero-whatsapp",
    name: "Llavero WhatsApp NFC",
    description: "Abre el contacto de tu negocio desde un llavero compacto.",
    price: "$10.000",
    priceValue: 10000,
    tag: "WhatsApp",
    category: "llaveros",
    availability: "disponible",
    image: "/productos/llavero-whatsapp.webp",
    gallery: ["/productos/llavero-whatsapp.webp"],
    imageFit: "contain",
    imageZoom: "keychain",
    imageSurface: "bg-[#dededc]",
  },
];

export type TramoVolumen = {
  cantidad: 1 | 3 | 5;
  descuento: number;
};

export const TRAMOS_VOLUMEN: TramoVolumen[] = [
  { cantidad: 1, descuento: 0 },
  { cantidad: 3, descuento: 15 },
  { cantidad: 5, descuento: 25 },
];

export const CONFIANZA_COMPRA = [
  {
    titulo: "Trato directo",
    texto: "Hablas directamente con la persona que revisa y realiza tu proyecto.",
  },
  {
    titulo: "Precio y alcance claros",
    texto: "Antes de comenzar sabrás qué incluye el servicio y cuánto tendrás que pagar.",
  },
  {
    titulo: "Te enseñamos a utilizarlo",
    texto: "No solo entregamos el trabajo: también te explicamos cómo aprovecharlo.",
  },
  {
    titulo: "Pensado para pymes",
    texto: "Soluciones profesionales sin la estructura ni los costos de una gran agencia.",
  },
] as const;

export function imagenesProducto(producto: Producto) {
  return producto.gallery?.length ? producto.gallery : [producto.image];
}

export function detallesProducto(producto: Producto) {
  const incluyeQr =
    producto.category !== "tarjetas" &&
    (producto.name.includes("QR") ||
      (producto.category === "llaveros" && producto.id !== "llavero-whatsapp"));
  const esStand = producto.category === "stands" || producto.id === "stand-personalizado";
  const formato =
    producto.category === "stands"
      ? "Stand para mesón"
      : producto.category === "tarjetas"
        ? "Tarjeta portátil"
        : producto.category === "llaveros"
          ? "Llavero portátil"
          : producto.id === "adhesivo-personalizado"
            ? "Adhesivo para vitrina"
            : "Stand personalizado";

  const dimensiones =
    producto.id === "stand-whatsapp"
      ? "14 cm de alto × 12 cm de ancho"
      : producto.id === "stand-personalizado"
        ? "15 cm de alto × 10 cm de ancho"
        : producto.id === "adhesivo-personalizado"
          ? "10 cm de alto × 10 cm de ancho"
          : producto.category === "stands"
            ? "13 cm de alto × 7,5 cm de ancho"
            : producto.category === "tarjetas"
              ? "8,5 cm de alto × 5 cm de ancho"
              : null;

  const material = esStand
    ? "PVC"
    : producto.category === "tarjetas"
      ? "PVC tipo tarjeta bancaria"
      : null;

  return {
    caracteristicas: [
      "Producto configurado y listo para usar al momento de la entrega.",
      "Configuración del enlace de tu negocio antes de la entrega.",
      incluyeQr
        ? "Incluye conexión NFC y código QR como alternativa."
        : "Incluye chip NFC programado y probado.",
    ],
    especificaciones: [
      { etiqueta: "Formato", valor: formato },
      { etiqueta: "Conectividad", valor: incluyeQr ? "NFC + QR" : "NFC" },
      ...(dimensiones ? [{ etiqueta: "Medidas", valor: dimensiones }] : []),
      ...(material ? [{ etiqueta: "Material", valor: material }] : []),
      { etiqueta: "Preparación", valor: "Configurado y probado antes de entregar" },
      {
        etiqueta: "Disponibilidad",
        valor: producto.availability === "disponible" ? "Disponible" : "Hecho a pedido",
      },
    ],
  };
}

export function precioUnitario(producto: Producto, tramo: TramoVolumen) {
  const valorConDescuento = producto.priceValue * (1 - tramo.descuento / 100);
  return Math.round(valorConDescuento / 100) * 100;
}

export function formatearPrecio(valor: number) {
  return `$${valor.toLocaleString("es-CL")}`;
}

export function whatsappProducto(producto: Producto, cantidad = 1) {
  const mensaje = `Hola, quiero comprar ${cantidad} ${cantidad === 1 ? "unidad" : "unidades"} de ${producto.name}. ¿Me ayudan con la configuración y la entrega?`;
  return `${WHATSAPP_BASE}?text=${encodeURIComponent(mensaje)}`;
}
